import React, { useState } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import LoginImage from "../../../Assets/images/Login_image.png";
import { useDispatch, useSelector } from "react-redux";
import { loginApi } from "./loginSlice";
import { useNavigate } from "react-router-dom";
import { AuthOHelper } from "../../../Common/Config";
import { ToastContainer, toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loginPayload, setLoginPayload] = useState({});
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  const store = useSelector((state) => state.loginReducer);
  const handleSubmit = async () => {
    if (
      document.getElementById("emailInput").checkValidity() &&
      document.getElementById("passwordInput").checkValidity()
    ) {
      setLoading(true);
      try {
        const result = await AuthOHelper().post(`/user/login`, loginPayload);
        if (result.status === 200) {
          localStorage.setItem("userData", JSON.stringify(result.data.data));
          localStorage.setItem(
            "token",
            JSON.stringify(result.data.data.accessToken)
          );
          dispatch(loginApi(result.data.data));
          navigate(-1);
          setLoading(false);
        }
      } catch (error) {
        console.log(error.response.data.error);
        toast.error(error.response.data.error);
        setLoading(false);
      }
    }
    setValidated(true);
  };
  const handleChange = (e) => {
    setLoginPayload({
      ...loginPayload,
      [e.target.name]: e.target.value,
    });
  };

  console.log("storessssss", store);
  return (
    <>
      <ToastContainer />
      <Container className="py-5">
        <Breadcrumb>
          <Breadcrumb.Item>
            <small
              className="Login_BreadCrumbs_style"
              onClick={() => navigate("/")}
            >
              Home
            </small>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <small
              className="Login_BreadCrumbs_style"
              onClick={() => navigate("/category/MicrosoftOffice")}
            >
              Shop
            </small>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            <small className="Login_BreadCrumbs_style">Login</small>
          </Breadcrumb.Item>
        </Breadcrumb>

        <Card className="Cart_Small_Card box_shadow">
          <Card.Body className="p-0">
            <Row>
              <Col md={6} xl={6} lg={6}>
                <img src={LoginImage} alt="AbouImg" className="Login_Img" />
              </Col>
              <Col
                md={6}
                xl={6}
                lg={6}
                className="About_Card_Para black_text p-5"
              >
                <Card.Title className="h6 my-4 ">Customer Login</Card.Title>
                <Form validated={validated}>
                  <Form.Group className="mt-4">
                    <Form.Label className="text-muted">
                      <small>Username (email address)</small>
                    </Form.Label>
                    <Form.Control
                      required
                      type="email"
                      id="emailInput"
                      placeholder="name@example.com"
                      name="email"
                      onChange={handleChange}
                      className="Login_InputFields"
                    />
                    <Form.Label className="text-muted mt-4">
                      <small>Password</small>
                    </Form.Label>
                    <Form.Control
                      required
                      type="password"
                      placeholder="password"
                      name="password"
                      id="passwordInput"
                      onChange={handleChange}
                      className="Login_InputFields"
                    />
                    <Button
                      variant="link"
                      className="forget_Password mt-4"
                      onClick={() => navigate("/forgetPassword")}
                    >
                      <small>Forget Password?</small>
                    </Button>
                    <br />
                    <Button
                      className="SignIn_Btn mt-2 blue_bg"
                      onClick={handleSubmit}
                    >
                      {loading ? (
                        <span
                          class="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        ""
                      )}
                      Sign In
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default Login;
